import type { Action } from 'state/actions';
import { addKeys, addOrReplaceKey, removeKeys } from 'state/utils/collection';

import type { FormFieldMetadataStateMap } from '../../../common-form/metaData/fields/fields.model';
import * as actionTypes from '../../batchForm.actionTypes';

export function fieldsReducer(state: FormFieldMetadataStateMap = {}, action: Action): FormFieldMetadataStateMap {
  switch (action.type) {
    case actionTypes.DEFAULT_BATCH_FORM_RECEIVED:
      return addOrReplaceKey(state, action.negotiationId, action.fieldsMetadata);
    case actionTypes.BATCH_FORM_ENRICHMENT_RECEIVED:
      return addOrReplaceKey(state, action.formId, action.fieldsMetadata);
    case actionTypes.BATCH_FORMS_DELETED:
      return removeKeys(state, action.formIds);
    case actionTypes.BATCH_FORMS_CLONE_REQUESTED:
      return addKeys(state, action.temporaryFormIds, Object.values(action.formsMetadataToBeCloned));
    default:
      return state;
  }
}
